<script lang="ts">
	import { AdvancedCardV2, LabelV2, LabelListV2 } from '@Shelly/shelly-design-system';
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	//Types
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let status: VCInterfaceStatus;
</script>

<AdvancedCardV2 title={translateTemplateTitle(status.name)} class="mb-s">
	<LabelListV2
		size="m"
		backgroundColor="--color-1"
		labelList={status.labelList || []}
		slot="main"
		data-prevent-drawer-swipe
		data-prevent-sidepanel-swipe
		a11yProps={{ isInteractive: true }}
	/>
	<div slot="right">
		<LabelV2
			style="max-width: 100%;"
			size="l"
			value={translateTemplateTitle(status.label || status.value)}
			icon={status.icon}
		/>
	</div>
</AdvancedCardV2>
